export const CoreUsersCurrentName = 'CoreUsersCurrent';
